import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import * as Sentry from '@sentry/react'

import reducers from './reducers'
import rootSaga from './sagas'

import postMessageMiddleware from 'redux/middlewares/post_message_middleware'
import metricsMiddleware from 'redux/middlewares/metrics_middleware'
import redirectMiddleware from 'redux/middlewares/redirect_middleware'
import generalMiddleware from 'redux/middlewares/general_middleware'

export const sagaMiddleware = createSagaMiddleware()

const sentryReduxEnhancer = Sentry.createReduxEnhancer()

const composeStore = compose(
	applyMiddleware(
		redirectMiddleware,
		metricsMiddleware,
		sagaMiddleware,
		generalMiddleware,
		postMessageMiddleware,
	),
	sentryReduxEnhancer,
	window.devToolsExtension ? window.devToolsExtension() : f => f
)(createStore)

const store = composeStore(reducers)

sagaMiddleware.run(rootSaga)

export default store
